import { render } from "./FrontVipInput.vue?vue&type=template&id=9fa980d4&scoped=true"
import script from "./FrontVipInput.vue?vue&type=script&lang=js"
export * from "./FrontVipInput.vue?vue&type=script&lang=js"

import "./FrontVipInput.vue?vue&type=style&index=0&id=9fa980d4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa980d4"]])

export default __exports__